
var DEMOGRAPHICS_DATAPOINTS = [
    "sex",
    "age",
    'race',
    "marital_status",
    "parental_status",
    "housing_status",
    "foster_care",
    "economically_disadvantaged",
    "lgbtq_identity",
    "recently_employed"];

var HORIZONTAL_DATAPOINTS = {
    sex: true, lgbtq_identity: true, recently_employed: true
}

module.config(function($stateProvider, TagUrl, moment) {
    var currentYear = moment().year().toString()

    var url = new TagUrl()
        .addTagTypes(['program', 'location', 'participant'])
        .setTagDefault('affiliation', 'all')
        .setTagDefault('year', currentYear);

    var programUrl = new TagUrl()
        .addTagTypes(['participant'])
        .setTagDefault('year', currentYear);

    $stateProvider.state('reports.demographics', {
        abstract: true,
        url: url.buildUrl('/demographics'),
        params: url.params,
        data: {tagUrl: url},
        reloadOnSearch: false,
        templateUrl: "reports/demographics/base",
        controller: 'TagRefreshEmitter',
        controllerAs: 'ctrl',
    });

    $stateProvider.state('reports.demographics.index', {
        url: '',
        reloadOnSearch: false,
        templateUrl: 'reports/demographics/index',
        controller: "DemographicsIndexReport",
        controllerAs: 'ctrl',
        resolve: {
            report: function(DemographicsIndexReport) {
                return new DemographicsIndexReport();
            }
        }
    });

    $stateProvider.state("reports.demographics.details", {
        url: '/:datapoint?{page:int}{sort}{direction}',
        params: {page: {value: 1, squash: true},
                 sort: {value: 'name', squash: true},
                 direction:{value: 'asc', squash: true}},
        reloadOnSearch: false,
        templateUrl: 'reports/demographics/details',
        controller: 'DemographicsDetailController',
        controllerAs: 'ctrl',
        resolve: {
            report: function($stateParams, DemographicsDetailReport) {
                return new DemographicsDetailReport($stateParams.datapoint);
            }
        }
    });

    $stateProvider.state("program.reports.demographics", {
        abstract: true,
        url: url.buildUrl('/demographics'),
        params: url.params,
        data: {tagUrl: url},
        reloadOnSearch: false,
        templateUrl: "reports/demographics/base",
        controller: 'TagRefreshEmitter',
        controllerAs: 'ctrl',
    });

    $stateProvider.state('program.reports.demographics.index', {
        url: '',
        reloadOnSearch: false,
        templateUrl: 'reports/demographics/index',
        controller: "DemographicsIndexReport",
        controllerAs: 'ctrl',
        resolve: {
            report: function(program, DemographicsIndexReport) {
                return new DemographicsIndexReport(program);
            }
        }
    });

    $stateProvider.state("program.reports.demographics.details", {
        url: '/:datapoint?{page:int}{sort}{direction}',
        params: {page: {value: 1, squash: true},
                 sort: {value: 'name', squash: true},
                 direction:{value: 'asc', squash: true}},
        reloadOnSearch: false,
        templateUrl: 'reports/demographics/students',
        controller: 'DemographicsDetailController',
        controllerAs: 'ctrl',
        resolve: {
            report: function($stateParams, program, DemographicsDetailReport) {
                return new DemographicsDetailReport($stateParams.datapoint, program);
            }
        }
    });

});


module.controller("DemographicsDetailController", function($scope, $stateParams,
                                                           ModelConfig, report,
                                                           BasicOptions) {
    this.report = $scope.report = report;
    this.datapoint = report.datapoint;

    $scope.triggerRefresh()
    $scope.$on('tagRefresh', function(event, params) {
        report.update(params);
    });

    this.linkParams = function(program) {
        var params = {slug: program.slug};
        angular.extend(params, $stateParams)
        return params;
    };

    this.isArray = angular.isArray;
    this.flex_percent = Math.min(95 / report.options.length, 18);

});


module.controller('DemographicsIndexReport', function($scope, $stateParams, report) {
    this.report = $scope.report = report;
    this.ageOptions = "commonAges";
    $scope.triggerRefresh()
    $scope.$on('tagRefresh', function(event, params) {
        report.update(params);
    });
});


module.service('DemographicsIndexReport', function(Report, $state) {
    Report.makeChildClass(DemographicsIndexReport);
    function DemographicsIndexReport(program) {
        this._filter_name = undefined;
        this._filter_value = undefined;

        url = ['reports', 'demographics'];
        if (program && program.id) url.push(program.id);
        Report.call(this, url);
    }

    Report.addExtraParameter(DemographicsIndexReport, 'filter_name');
    Report.addExtraParameter(DemographicsIndexReport, 'filter_value');

    DemographicsIndexReport.prototype.getExtraParams = function() {
        var extra = {};
        if (this.filter_name && this.filter_value) {
            extra[this.filter_name] = this.filter_value;
        }
        return extra;
    };

    DemographicsIndexReport.prototype.setFilter = function(name, value) {
        if (this.filter_name === name && this.filter_value === value) {
            this.filter_name = undefined;
            this.filter_value = undefined;
        } else {
            this.filter_name = name;
            this.filter_value = value;
        }
    };

    return DemographicsIndexReport;
});

module.service('DemographicsDetailReport', function(Report, ModelConfig, BasicOptions) {
    var booleanDatapoints = ['english_learner', 'economically_disadvantaged'];

    Report.makeChildClass(DemographicsDetailReport);
    function DemographicsDetailReport(name, program) {
        var datapoint_name = name.split('-').join('_'),
            url = ['reports', 'demographics', datapoint_name];

        this.datapoint = datapoint_name;
        this.options = getOptions(this.datapoint);
        this.label = this.datapoint === 'age' ? 'Age' : ModelConfig.getLabel(this.datapoint);
        this.$sorterConfig = {
            default: 'name',
            direction: 'asc',
            columns: ['name'],
        };

        if (program && program.id) {
            url.push(program.id);
            this.$sorterConfig.columns.push(this.datapoint);
        } else {
            this.$sorterConfig.columns.push.apply(this.$sorterConfig.columns,
                                                  this.options);
        }
        Report.call(this, url);
    }

    DemographicsDetailReport.prototype.$isList = true;

    // Report.makeGetter(DemographicsDetailReport, '$sorterConfig', function() {
    //     return {columns: this.options};
    // });

    function getOptions(datapoint) {
        if (datapoint === 'age') {
            return BasicOptions.commonAges;
        } else if (booleanDatapoints.indexOf(datapoint) >= 0) {
            return BasicOptions.booleanString;
        } else {
            return ModelConfig.getOptions(datapoint);
        }
    }

    return DemographicsDetailReport;

});

module.directive("demographicBubbles", function(ModelConfig) {
    return {
        restrict: 'E',
        templateUrl: 'reports/demographics/DemographicsBubbleDirective',
        transclude: true,
        scope: {
            datapoint: '@',
            report: '=',
            horizontal: '=',
            title: '=?',
            options: "=?",
        },
        link: function(scope, element, attrs) {

            if (!attrs.title) {
                scope.title = ModelConfig.getLabel(scope.datapoint);
            }

            if (!attrs.options) {
                scope.options = ModelConfig.getOptions(scope.datapoint);
            }

            scope.setFilter = scope.report.setFilter.bind(scope.report);

            scope.datapointSelected = function(datapoint) {
                return scope.report.filter_name === datapoint
                    && scope.report.filter_value;
            };

            scope.click = function() {
                scope.asTable = !scope.asTable;
            }
        }
    }
});


module.directive('demographicDetailsRow', function() {
    return {
        restrict: 'A',
        templateUrl: 'reports/demographics/detailsRow',
        scope: {data: '=demographicDetailsRow', options: '='},
        transclude: true,
    };
});